import { render, staticRenderFns } from "./TrunkUnitComparisonModal.vue?vue&type=template&id=a5493616&scoped=true&"
import script from "./TrunkUnitComparisonModal.vue?vue&type=script&lang=js&"
export * from "./TrunkUnitComparisonModal.vue?vue&type=script&lang=js&"
import style0 from "./TrunkUnitComparisonModal.vue?vue&type=style&index=0&id=a5493616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5493616",
  null
  
)

export default component.exports